import React, {PureComponent, Fragment} from 'react';
import styled from 'styled-components';

import * as validation from '../../lib/validation';
import Icon from '../Icon';
import Button from '../Button';
import Input from '../Input';

const validAnswer = validation.create((answer, {isDecimal}) => isDecimal(answer));
const allAnswersValid = values => values.every(validAnswer);

class MultiNumericInput extends PureComponent {
  componentDidMount() {
    const {values, onChange} = this.props;

    if (values.length < 1) {
      onChange([''], false);
    }
  }

  render() {
    const {label, question, values, onChange, invalid} = this.props;

    return (
      <Fragment>
        {values.map((value, i) => {
          const isFirstValue = i === 0;
          const isLastValue = i === values.length - 1;

          return (
            <Row key={i}>
              <Input
                id={`answer-${question.id}-${i}`}
                label={isFirstValue && label}
                type="number"
                step="any"
                value={value}
                onChange={e => onChange(values.map((value, j) => i === j ? e.target.value : value), allAnswersValid(values))}
                invalid={invalid && !validAnswer(value + '')}
                validationText="Please enter a number"
              />
              {isLastValue ? (
                <Button tertiary onClick={() => onChange([...values, ''], false)}>
                  <Icon name="plus" />
                </Button>
              ) : (
                <Button tertiary onClick={() => onChange(values.filter((_, j) => j !== i), allAnswersValid(values))}>
                  <Icon name="trash-2" />
                </Button>
              )}
            </Row>
          );
        })}
      </Fragment>
    );
  }
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 0.25rem;

  :first-child {
    margin-top: 0;
  }
`;

export default MultiNumericInput;
